import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './tufts-other-location-result.css.lit';
import tuftsHeadingCssLit from '../tufts-heading/tufts-heading.css.lit';
import '../tufts-heading/tufts-heading';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { SlotNGController } from '../../controllers/slot-ng-controller';

/**
 * The tuftsOtherLocationResult component
 * @element tufts-other-location-result
 *
 * @slot hours
 */
@customElement('tufts-other-location-result')
export class tuftsOtherLocationResult extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles, tuftsHeadingCssLit];
  ngSlot = new SlotNGController(this);

  render(): TemplateResult {
    return html` <div class="main-wrapper">
      ${this.ngSlot.conditionalNGSlot('location-name')}
      ${this.ngSlot.conditionalNGSlot('address')}
      <div class="additional-information-wrapper">
        ${this.ngSlot.conditionalNGSlot('additional-information')}
      </div>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-other-location-result': tuftsOtherLocationResult;
  }
}
